import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import { Fade, Typography } from '@mui/material'
import { motion } from 'motion/react'
import { ReactComponent as CloseRoundedIcon } from '../../images/close.svg'
import UseTranslation from '../../hooks/UseTranslation'
import { BtnsHoverAnimation } from '../../utils/animation'

const FormModalContainer = ({
  modalState,
  handleClose,
  children,
  modalTitle,
  mediumSize,
  largeSize,
  customWidth,
  customStyle,
  customModalStyle,
  keepMounted,
  cancelText,
  modalSubTitle,
  borderStyle,
  disappearCancelButton,
}) => {
  const { t } = UseTranslation()

  return (
    <Modal
      open={modalState}
      onClose={handleClose}
      sx={[styles.root, customStyle]}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      keepMounted={keepMounted}
    >
      <Fade in={modalState}>
        <Box
          sx={[
            styles.modalBody,
            { width: customWidth },
            customModalStyle,
            mediumSize && styles.mediumSize,
            largeSize && styles.largeSize,
          ]}
          className="model-body"
          data-testid="model-body"
        >
          <Box
            sx={[styles.modalHeader, !borderStyle && styles.borderStyle]}
            className="modalHeader"
          >
            <Box sx={styles.title}>
            <Typography variant="h5">{modalTitle}</Typography>
           <Box
              sx={styles.close}
              className="close-btn"
              component={motion.div}
              variants={BtnsHoverAnimation}
              whileHover="hover"
            >
              <CloseRoundedIcon onClick={handleClose} className="close-bun" data-testid="closeIcon" />
              {!disappearCancelButton && (
              <Typography onClick={handleClose}>
                {cancelText || t?.Cancel}
              </Typography>
              )}
                 </Box>
            </Box>
              {modalSubTitle && <Typography variant="h6">{modalSubTitle}</Typography>}
          </Box>
          {children}
        </Box>
      </Fade>
    </Modal>
  )
}
const styles = {
  root: {
    zIndex: 999,
  },
  modalBody: {
    position: { xs: 'fixed', sm: 'absolute' },
    bottom: { xs: 0, sm: 'initial' },
    left: { xs: 0, sm: '50%' },
    right: { xs: 0, sm: 'initial' },
    top: { xs: 'none', sm: '50%' },
    transform: { xs: 'initial', sm: 'translate(-50%, -50%)' },
    minWidth: { xs: '90%', sm: '379px' },
    maxHeight: { xs: '80%', sm: '580px' },
    overflow: 'auto',
    overflowX: 'hidden',
    backgroundColor: 'background.paper',
    '&:focus': {
      outline: 'none',
    },
    border: 0,
    boxShadow: 0,
    p: 2,
    borderRadius: '3px',
    '::-webkit-scrollbar': {
      width: '0.4em',
    },
    '::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '::-webkit-scrollbar-thumb': {
      backgroundColor: 'primary.main',
    },
  },
  borderStyle: {
    borderBottom: '1px solid #dddddd',
  },
  modalHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: { xs: '0 0 10px', sm: '0 0 10px' },
    textTransform: 'capitalize',
    backgroundColor: 'white',
    zIndex: 999,
    '& h5': {
      fontFamily: 'Avenir-bold',
      fontSize: { xs: '16px', sm: '18px' },
    },
    '& h6': {
      fontFamily: 'Avenir',
      color: 'text.hint',
      fontSize: { xs: '12px', sm: '14px' },
      marginTop: '5px',
    },
    svg: {
      color: 'success.main',
      fontSize: '20px',
      cursor: 'pointer',
    },
  },
  mediumSize: {
    minWidth: 'unset',
    width: { xs: 'initial', sm: '90vw' },
    maxWidth: '596px',
  },
  largeSize: {
    minWidth: 'unset',
    width: { xs: 'initial', sm: '90vw' },
    maxWidth: '1068px',
  },
  close: {
    color: '#29cc8b',
    fontSize: { xs: '16px', sm: '18px' },
    fontWeight: '500',
    cursor: 'pointer',
    '& svg': { display: { sm: 'block', xs: 'none' } },
    '& p': {
      display: {
        sm: 'none', xs: 'block',
      },
      fontSize: { xs: '16px', sm: '18px' },
    },
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
  },
}
export default FormModalContainer
